import { render } from "./EditProduct.vue?vue&type=template&id=444b631b&scoped=true"
import script from "./EditProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProduct.vue?vue&type=script&setup=true&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=444b631b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444b631b"],['__file',"resources/js/modules/product-submission/components/EditProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "444b631b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('444b631b', __exports__)) {
    api.reload('444b631b', __exports__)
  }
  
  module.hot.accept("./EditProduct.vue?vue&type=template&id=444b631b&scoped=true", () => {
    api.rerender('444b631b', render)
  })

}


export default __exports__